import React from 'react';
import { Link } from 'react-router-dom';
import { Factory, Package, Wrench, Cog } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

export const Catalog = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const categories = [
    {
      id: 'conveyor',
      icon: Factory,
      title: t.services.conveyor.title,
      description: t.services.conveyor.description,
      link: '/services/conveyor',
      image: '/images/machines/conveyor-1.jfif'
    },
    {
      id: 'chocolate',
      icon: Package,
      title: t.services.chocolate.title,
      description: t.services.chocolate.description,
      link: '/services/chocolate',
      image: '/images/machines/wafer-cutting-1.jfif'
    },
    {
      id: 'cnc',
      icon: Wrench,
      title: t.services.cnc.title,
      description: t.services.cnc.description,
      link: '/services/cnc',
      image: '/images/machines/cnc-parts-1.png'
    },
    {
      id: 'custom',
      icon: Cog,
      title: t.services.custom.title,
      description: t.services.custom.description,
      link: '/services/custom',
      image: '/images/machines/mamul-asansor.png'
    }
  ];

  return (
    <div className="min-h-screen pt-32 pb-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t.catalog.title}
          </h1>
          <p className="text-xl text-gray-600">{t.catalog.subtitle}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={category.link}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer group"
            >
              <div className="h-64 overflow-hidden relative">
                <img
                  src={category.image}
                  alt={category.title}
                  className={`w-full h-full object-cover group-hover:scale-110 transition-transform duration-300 ${category.id === 'helical' ? 'object-[center_30%]' : ''}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center space-x-3 mb-2">
                    <div className="w-10 h-10 bg-blue-700 rounded-lg flex items-center justify-center">
                      <category.icon className="text-white" size={20} />
                    </div>
                    <h3 className="text-xl font-bold text-white">{category.title}</h3>
                  </div>
                </div>
              </div>
              <div className="p-6">
                <p className="text-gray-600 mb-4 hidden md:block">{category.description}</p>
                <span className="text-blue-700 font-semibold hover:text-blue-800 transition-colors">
                  {t.catalog.viewDetails} →
                </span>
              </div>
            </Link>
          ))}
        </div>

        {/* Teklif Al Butonu */}
        <div className="text-center mt-16">
          <Link
            to="/contact"
            className="inline-flex items-center px-8 py-4 bg-blue-700 hover:bg-blue-800 text-white text-lg font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300"
          >
            {language === 'tr' ? 'Teklif Al' : 'Get Quote'}
          </Link>
        </div>
      </div>
    </div>
  );
};
